import z from "zod";

import { ActivationSchema } from "../../models";

export const Select = {
  type: true,
  status: true
} as const;

export const Schema = ActivationSchema.pick(Select);

export type Type = z.infer<typeof Schema>;
